import React from 'react';
import SignUp from '../features/auth/components/SignUp';

const SignUpPage = () => {
  return <SignUp />;
};

export default SignUpPage;
